module.exports = __webpack_public_path__ + "static/img/2.1f4e0b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/sp/2.png
// module id = KAya
// module chunks = 0